import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

import {
	TOfferSpendByOfferScopeAggOnly,
	TOfferSpendByOfferScopeDay,
	EOfferSpendByOfferScopeView,
} from '../../types'
import { ToolPanel } from '../ui'
import { OfferSpendByOfferScopeDetailsTable } from './OfferSpendByOfferScopeDetailsTable'
import { useTranslation } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'

type IOfferSpendByOfferScopeDetailsModal = {
	viewBy: EOfferSpendByOfferScopeView;
	offerSpend: TOfferSpendByOfferScopeDay | TOfferSpendByOfferScopeAggOnly | null;
	show: boolean;
	take: number | 'all';
	onClose: () => void;
}

export const OfferSpendByOfferScopeDetailsModal = (
	props: IOfferSpendByOfferScopeDetailsModal
) => {
	const { viewBy, offerSpend, show, take = 10, onClose } = props
	const { t } = useTranslation()
	const [page, setPage] = useState<number>(0)
	const skip = (take === 'all') ? 0 : page > 0 ? page * take : 0

	const isSingleView = !!(offerSpend && ('scopeId' in offerSpend))
	const offerScopeLabel = isSingleView && `'${offerSpend?.scope?.name ?? ''}' [id: ${offerSpend?.scopeId ?? ''}]`
	const dayLabel = offerSpend?.day

	return <>
		<Modal show={show} onHide={onClose} size="xl" className={'modal-with-sticky scroll'}>
			<Modal.Header className={'modal-header--sticky'} closeButton>
				<Modal.Title>
					{
						isSingleView ?
							`${t(ALL_LANG_KEY.offer_spend_crud_modal.title_by_offer_scope, { offerScope: offerScopeLabel, date: dayLabel })}` :
							`${t(ALL_LANG_KEY.offer_spend_crud_modal.title_by_offer_scope_total, { date: dayLabel })}`
					}
				</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<OfferSpendByOfferScopeDetailsTable
					items={offerSpend?.agg ?? []}
					skip={skip}
					showDateColumn={viewBy === EOfferSpendByOfferScopeView.Month}
				/>
			</Modal.Body>

			<Modal.Footer className={'modal-footer--sticky'}>
				<ToolPanel flow="<-" width={'100%'}>
					<Button variant="secondary" onClick={onClose}>{`${t(ALL_LANG_KEY.offer_spend_crud_modal.btn_close)}`}</Button>
				</ToolPanel>

			</Modal.Footer>
		</Modal>
	</>
}
